
const messageList = () => import('../views/msg/index');
export default [
  {
    path: '/messageList',
    name: '留言列表',
    component: messageList,
    meta: [{ name: '留言管理' }]
  },

];
